import { render, staticRenderFns } from "./doge.vue?vue&type=template&id=ed5af574&scoped=true"
import script from "./doge.vue?vue&type=script&lang=js"
export * from "./doge.vue?vue&type=script&lang=js"
import style0 from "./doge.vue?vue&type=style&index=0&id=ed5af574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5af574",
  null
  
)

export default component.exports